/* Coffee Notes: short product names on product cards (full names stay in the page for search). */
(function(){
  function shortName(t){
    if(/Christmas Blend/i.test(t)) return 'Christmas Blend';
    if(t.indexOf(' | ')>-1) return t.split(' | ')[0];
    if(t.indexOf(' - ')>-1) return t.split(' - ')[0];
    return t;
  }
  function run(root){
    (root||document).querySelectorAll('.product-card-wrapper .card__heading a').forEach(function(a){
      if(a.dataset.cnShort) return;
      var full=a.textContent.trim();
      a.textContent=shortName(full);
      a.title=full;
      a.dataset.cnShort='1';
    });
  }
  document.addEventListener('DOMContentLoaded',function(){
    run();
    new MutationObserver(function(){run();}).observe(document.body,{childList:true,subtree:true});
  });
})();
